import { j as r } from "../../../_virtual/jsx-runtime.js";
import m from "../SkeletonWrapper/index.js";
const l = ({
  size: t = 32,
  background: n = "white",
  borderColor: e = "transparent",
  color: s,
  children: i,
  borderWidth: a = 2,
  isLoading: d
}) => /* @__PURE__ */ r.jsx(m, { isLoading: d, circle: !0, children: /* @__PURE__ */ r.jsx(
  "div",
  {
    className: "flex items-center justify-center rounded-full text-xs font-medium",
    style: {
      width: t,
      height: t,
      background: n,
      borderWidth: e !== "transparent" ? a : 0,
      borderColor: e,
      color: s
    },
    children: i
  }
) });
export {
  l as default
};
